//#region imports
import { FC } from 'react';

import { TRequest } from '../../models/request';
import ModalInfo from './components/Info';
import ModalSuccess from './components/Success';
//#endregion

interface IProps {
  readonly request: TRequest;
  readonly hasVisible: boolean;
  toggleModal?(): void;
}

const Modals: FC<IProps> = ({
  request,
  toggleModal,
  hasVisible
}) => {

  if (!hasVisible) return null;

  return (
    <>
      <ModalInfo

        open={ hasVisible && request?.status === 'err' }
        onClose={ toggleModal }
      />
      <ModalSuccess
        open={ hasVisible && request?.status === 'ok' }
        onClose={ toggleModal }
      />
    </>
  );
};

export default Modals;
